import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

const simpleTimer = () => {
  dayjs.extend(duration);

  const timerElements = document.querySelectorAll(`.js-simple-timer`);
  const now = new Date();

  const timerInit = (timerElement) => {
    let timeToEndSaleData = dayjs.duration(JSON.parse(timerElement.dataset.timerTime)).asMilliseconds();

    const hoursEl = timerElement.querySelector(`.js-timer-hours`);
    const minutesEl = timerElement.querySelector(`.js-timer-minutes`);
    const secondsEl = timerElement.querySelector(`.js-timer-seconds`);

    const timeCount = () => {
      const timeToEnd = new Date(dayjs() + timeToEndSaleData).getTime();

      const daysInHours = Math.floor((timeToEnd - now.getTime()) / 1000 / 60 / 60 / 24) * 24;
      const hours = Math.floor((timeToEnd - now.getTime()) / 1000 / 60 / 60) % 24;
      const minutes = Math.floor((timeToEnd - now.getTime()) / 1000 / 60) % 60;
      const seconds = Math.floor((timeToEnd - now.getTime()) / 1000) % 60;

      hoursEl.textContent = hours + daysInHours < 10 ? `0${hours + daysInHours}` : hours + daysInHours;
      minutesEl.textContent = minutes < 10 ? `0${minutes}` : minutes;
      secondsEl.textContent = seconds < 10 ? `0${seconds}` : seconds;

      timeToEndSaleData = timeToEndSaleData - 2000;
    };

    timeCount();
    setInterval(timeCount, 1000);
  }

  if (timerElements.length) {
    timerElements.forEach(timerInit);
  }
}

export {simpleTimer};
